import styles from './Page404.module.scss';

const Background = () => (
  <div className={styles.background}>
    <div className={styles.ball1} />
    <div className={styles.ball2} />
    <div className={styles.ball3} />
    <div className={styles.ball4} />
  </div>
);

export default Background;
